import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import  DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';

const Actions = ({ rowData }) => {
    const navigate = useNavigate();

    return (
        <span className="flex flex-row justify-center">
            <Tooltip
                title="ویرایش تخفیف"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => navigate("/discounts/add-discount", {
                        state: rowData
                    })}
                >
                    <EditIcon className="text-yellow-400" />
                </IconButton>
            </Tooltip>
        </span>
    );
}

export default Actions;
